import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zis',
  templateUrl: './zis.component.html',
  styleUrls: ['./zis.component.scss']
})
export class ZisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
